export default "__VITE_ASSET__CEUhYNum__"